import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Images/logo-w.png';
import {  useNavigate } from 'react-router-dom';

const Signup = () => {
  const navigate = useNavigate()
  const [referrerMobile, setReferrerMobile] = useState('');
const [referrerOtp, setReferrerOtp] = useState('');
const [referrerId, setReferrerId] = useState(null);
const [referrerName, setReferrerName] = useState('');
const [otpSent, setOtpSent] = useState(false);
const [isReferrerVerified, setIsReferrerVerified] = useState(false);
const [sendingOtp, setSendingOtp] = useState(false);
const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    password: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleSendReferrerOtp = async () => {
  if (!referrerMobile.trim()) {
    alert('Please enter referrer mobile number');
    return;
  }
  setSendingOtp(true);
  try {
    const res = await fetch('http://10.104.185.120:4008/auth/api/send-referrer-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referrerMobile: referrerMobile.trim() }),
    });
    const data = await res.json();
    if (data.success) {
      alert(data.message);
      setReferrerId(data.referrerId);
      setReferrerName(data.referrerName);
      setOtpSent(true);
    } else {
      alert(data.message || 'Failed to send OTP to referrer');
    }
  } catch (err) {
    console.error(err);
    alert('Error connecting to server');
  } finally {
    setSendingOtp(false);
  }
};

const handleVerifyReferrerOtp = async () => {
  if (!referrerOtp.trim()) {
    alert('Please enter OTP');
    return;
  }
  setVerifyingOtp(true);
  try {
    const res = await fetch('http://10.104.185.120:4008/auth/api/verify-referrer-otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referrerId, otp: referrerOtp.trim() }),
    });
    const data = await res.json();
    if (data.success) {
      alert(data.message);
      setIsReferrerVerified(true);
    } else {
      alert(data.message || 'Invalid OTP');
    }
  } catch (err) {
    console.error(err);
    alert('Error verifying OTP');
  } finally {
    setVerifyingOtp(false);
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Basic validation
    const validationErrors = {};
    if (!formData.name) validationErrors.name = 'Name is required';
    if (!formData.email) validationErrors.email = 'Email is required';
    if (!formData.mobile) validationErrors.mobile = 'Mobile number is required';
    if (!formData.password) validationErrors.password = 'Password is required';
    if (formData.password !== formData.confirmPassword) validationErrors.confirmPassword = 'Passwords do not match';
  
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
  
    try {
      const response = await fetch('http://10.104.185.120:4008/auth/api/sign-up', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: formData.name,
          email: formData.email,
          mobile: formData.mobile,
          password: formData.password,
          referrerId: isReferrerVerified ? referrerId : null,
  referrerMobile: isReferrerVerified ? referrerMobile : null,
        }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to register user');
      }
  
      const data = await response.json();
  
      if (response.status === 200) {
        console.log(data);
        alert(data.message);
        navigate('/otp-verification');
  
        setFormData({
          name: '',
          email: '',
          password: '',
          confirmPassword: '',
          mobile: ''
        });
      } else {
        alert('Failed to register user. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error.message);
      alert(error.message || 'Something went wrong. Please try again.');
    }
  };



  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{
        background: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)',
        padding: '20px',
      }}
    >
      <div className="p-4" style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '400px', }}>
        <div className="text-center">
          <div style={{
      fontFamily: 'Arial, sans-serif',
      fontSize: '40px',
      fontWeight: 'bold',
      color: 'transparent',
      background: 'linear-gradient(to right, #3498db, #8e44ad)', // Gradient effect
      WebkitBackgroundClip: 'text', // Ensures text takes on the gradient color
      textAlign: 'center',
      marginBottom: '15px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)', // Shadow for a 3D effect
    }}>
      QuizifyAI
    </div>
          <h2 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
            Create an Account
          </h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500' }}>
              Full Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your full name"
            />
            {errors.name && <div className="text-danger">{errors.name}</div>}
          </div>

          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500' }}>
              Email Address
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your email"
            />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>

          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500' }}>
              Mobile Number
            </label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your mobile number"
            />
            {errors.mobile && <div className="text-danger">{errors.mobile}</div>}
          </div>

          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500' }}>
              Password
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="form-control"
              placeholder="Enter your password"
            />
            {errors.password && <div className="text-danger">{errors.password}</div>}
          </div>

          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: '500' }}>
              Confirm Password
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="form-control"
              placeholder="Confirm your password"
            />
            {errors.confirmPassword && <div className="text-danger">{errors.confirmPassword}</div>}
          </div>

          <div className="mb-3 p-3 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
  <label className="form-label" style={{ fontWeight: '600', fontSize: '13px' }}>
    Referred By (Approved Member Mobile) <span className="text-muted">(Optional)</span>
  </label>
  
  <div className="input-group mb-2">
    <input
      type="tel"
      className="form-control"
      placeholder="Referrer 10-digit mobile"
      value={referrerMobile}
      disabled={isReferrerVerified || otpSent}
      onChange={(e) => setReferrerMobile(e.target.value)}
    />
    <button
      type="button"
      className="btn btn-outline-primary"
      disabled={sendingOtp || isReferrerVerified || !referrerMobile}
      onClick={handleSendReferrerOtp}
    >
      {sendingOtp ? 'Sending...' : isReferrerVerified ? 'Verified ✓' : 'Send OTP'}
    </button>
  </div>

  {otpSent && !isReferrerVerified && (
    <div className="mt-2">
      <small className="text-success d-block mb-1">
        OTP sent to {referrerName}'s WhatsApp. Enter code:
      </small>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="6-digit WhatsApp OTP"
          value={referrerOtp}
          maxLength={6}
          onChange={(e) => setReferrerOtp(e.target.value)}
        />
        <button
          type="button"
          className="btn btn-success"
          disabled={verifyingOtp || !referrerOtp}
          onClick={handleVerifyReferrerOtp}
        >
          {verifyingOtp ? 'Verifying...' : 'Verify OTP'}
        </button>
      </div>
    </div>
  )}

  {isReferrerVerified && (
    <div className="text-success small mt-1 fw-bold">
      ✓ Referred by: {referrerName} ({referrerMobile})
    </div>
  )}
</div>

          <div className="d-grid gap-2">
            <button type="submit" className="btn btn-primary">
              Sign Up
            </button>
          </div>
        </form>

        <div className="text-center mt-3" style={{ fontSize: '14px' }}>
          <p>
            Already have an account?{' '}
            <a href="/login" className="text-decoration-none text-primary">
              Login here
            </a>
          </p>
        </div>

        <div className="text-center mt-4" style={{ fontSize: '12px', color: '#777' }}>
          <p>&copy; 2025 Quizifyai. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Signup;
